

















import { floorService } from "@/services/floor";
import { Floor } from "@/swagger/models";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "FloorSelector",
})
export default class FloorSelector extends Vue {
    @Prop({ required: true })
    officeId: number;

    @Prop({})
    returnObject: false;

    @Prop({})
    selectFirst: false;

    @Prop({})
    clearable: true;

    floors: Floor[] = [];
    loading: boolean = false;

    value: Floor | null = null;

    @Watch("officeId", { immediate: true })
    async refreshFloors() {
        try {
            this.loading = true;
            this.floors = await floorService.find({
                params: { office: this.officeId },
            });

            if (this.selectFirst) {
                this.value = this.floors[0];
                this.$emit("change", this.value);
            }
        } catch (e) {
            console.warn(e);
        } finally {
            this.loading = false;
        }
    }
}
